export default __webpack_public_path__ + "static/media/strips_subscription_guide@2x.247eb8d0.webp";